import { CreateOrder } from 'containers/CreateOrder';
import { TradeHistory } from 'containers/TradeHistory';
import { OrderBook } from 'containers/OrderBook';
import { TVChartContainer } from 'containers/TVChartContainer';
import { ExchangeWidgetContainer } from 'containers/ExchangeWidgetContainer';
import { DepthChart } from 'containers/DepthChart';
import { OpenOrdersTable, UserTradeHistoryTable, MyTradeHistoryTable } from 'containers/Tables';
import { WalletTable } from 'containers/Tables';

export const exchangeComponents = {
  DepthChart: {
    component: DepthChart,
    title: 'exchange.depthChart.title',
  },
  OrderBook: {
    component: OrderBook,
    title: 'exchange.orderBook',
  },
  PlaceHolder: {
    component: ExchangeWidgetContainer,
    title: 'exchange.placeholder',
  },
  TradeHistory: {
    component: TradeHistory,
    title: 'exchange.tradeHistory',
  },
  TVChartContainer: {
    component: TVChartContainer,
    title: 'exchange.chart',
  },
  OpenOrders: {
    component: OpenOrdersTable,
    title: 'Открытые ордера',
    extraProps: {
      isFilterable: false,
      exportable: false,
    },
  },
  OrderHistory: {
    component: UserTradeHistoryTable,
    title: 'История сделок',
    extraProps: {
      isFilterable: false,
      exportable: false,
      refetchInterval: 25000,
    },
  },
  MyTradeHistory: {
    component: MyTradeHistoryTable,
    title: 'История трейдов',
    extraProps: {
      isFilterable: false,
      exportable: false,
      refetchInterval: 25000,
    },
  },
  Portfolio: {
    component: WalletTable,
    title: 'Портфель',
    extraProps: {
      isFilterable: false,
      exportable: false,
      hideColumns: ['trade'],
    },
    showBalanceToggle: false,
  },
  CreateOrder: {
    component: CreateOrder,
    title: 'exchange.createOrder',
    extraProps: {
      tabProps: {
        className: 'top-border-radius draggableHandle',
      },
      tabItemProps: {
        className: 'draggableCancel',
      },
    },
  },
};
